import { useEffect } from 'react';
import { useFeatures } from '../contexts/FeaturesContext';
import { setUsageEventsEnabled } from '../lib/usageEvents';

/**
 * Передаёт флаг из FeaturesProvider в модуль событий. Отдельный компонент, потому что CallCenterApp
 * стоит выше провайдера. Пока ответа нет, флаги — лишь умолчания, и события копятся в буфере:
 * ранний false выбросил бы всё, что произошло на экране входа.
 */
const UsageEventsBridge = () => {
  const { features, isFeaturesLoaded } = useFeatures();

  useEffect(() => {
    if (isFeaturesLoaded) {
      setUsageEventsEnabled(features.usageAnalyticsEnabled);
    }
  }, [features.usageAnalyticsEnabled, isFeaturesLoaded]);

  return null;
};

export default UsageEventsBridge;
